import { MskScoreVersion } from "../../models/enumerations/msk-score-versions";
import { ReportWellnessData } from "../../models/interfaces/reports/report-wellness-data";
import { ReportWellnessDataV1, ReportWellnessDataV2 } from "../../models/interfaces/reports/report-wellness-data-versioned";
import ReportWellnessV1 from "./report-wellness-v1";
import ReportWellnessV2 from "./report-wellness-v2";

interface ReportWellnessProps {
    data: ReportWellnessData;
}

const ReportWellness: React.FC<ReportWellnessProps> = ({ data }) => {
    const version = data.mskVersion ?? MskScoreVersion.V1;

    switch (version) {
        case MskScoreVersion.V2:
            return <ReportWellnessV2 data={data as ReportWellnessDataV2} />;

        case MskScoreVersion.V1:
        default:
            return <ReportWellnessV1 data={data as ReportWellnessDataV1} />;
    }
};

export default ReportWellness;
